// app/(app)/page.tsx
"use client";

import { Portal } from "@/components/portal/Portal";
import SimpleLoader from "@/components/ui/SimpleLoader";
import { useKernelStore } from "@/kernel/kernelStores";
import { useKernel } from "@/kernel/Kernel";
import { DEFAULT_BACKDROP_THEME } from "@/components/layout/backdropTheme";
import clsx from "clsx";

export default function DashboardPage() {
  const { kernelReady } = useKernel();

  const dbUserId = useKernelStore((state) => state.userContext.dbUserId);

  const isPortalRuntimeReady = Boolean(dbUserId);

  if (!kernelReady || !isPortalRuntimeReady) {
    return (
      <div className="flex items-center justify-center w-full h-screen bg-black text-white">
        <SimpleLoader />
      </div>
    );
  }

  return (
    <div className="text-white w-full h-screen flex flex-col relative overflow-hidden isolate">
      <div
        className={clsx(
          "absolute inset-0 -z-10 pointer-events-none transition-opacity duration-500 opacity-100",
        )}
        style={{
          backgroundColor: DEFAULT_BACKDROP_THEME.baseColor,
        }}
      />

      <div className="relative z-10 flex h-full w-full flex-col">
        <main className="relative flex-1 min-w-0 overflow-hidden">
          <Portal />
        </main>
      </div>
    </div>
  );
}
